module.exports = __webpack_public_path__ + "static/media/HERO_Pycnandra_latex_credit_Antony_van_der_Ent_2.5ebbca91.jpg";